import React from 'react';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigate } from 'react-router';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import DateObject from 'react-date-object';

export default class PersonnelProductivityReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            fromDate: null,  
            toDate: null,
            records: []
        };
    }

    componentDidMount() {
        this.loadReport();
    }

    toISODate(dateObj) {
        if (!dateObj) return null;
        return dateObj.toDate().toISOString();
    }

    loadReport() {
        this.setState({ loading: true });

        this.httpPost('api/v1/report/personnel-productivity', {
            fromDate: this.toISODate(this.state.fromDate),
            toDate: this.toISODate(this.state.toDate)
        }).then(data => {
            if (data.status === 1) {
                this.setState({ records: data.records, loading: false, data: data });
            } else if (data.status === -5) window.location.href = "/access-denied"; else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    }

    renderForm() {
        const { records, fromDate, toDate, loading } = this.state;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گزارش بهره‌وری پرسنل</h3>
                        </div>
                    </div>
                </div>

                <div className="card card-bordered mb-3">
                    <div className="card-inner">
                        <div className="row g-3 align-items-end">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label">از تاریخ</label>
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        value={fromDate}
                                        onChange={date => this.setState({ fromDate: date })}
                                        format="YYYY/MM/DD"
                                        inputClass="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label">تا تاریخ</label>
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        value={toDate}
                                        onChange={date => this.setState({ toDate: date })}
                                        format="YYYY/MM/DD"
                                        inputClass="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-primary" onClick={() => this.loadReport()}>اعمال فیلتر</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {loading ? this.renderLoading() : (
                            records.length > 0 ? (
                                <div className="card-inner p-0">
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>کاربر</th>
                                                <th>تعداد کل</th>
                                                <th>انجام‌شده</th>
                                                <th>معوق</th>
                                                <th>میانگین زمان (ساعت)</th>
                                                <th>برگشتی</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.map(r => (
                                                <tr key={r.userId}>
                                                    <td>{r.fullName}</td>
                                                    <td>{r.total}</td>
                                                    <td>{r.completed}</td>
                                                    <td>{r.overdue}</td>
                                                    <td>{r.avgCompletionHours ? Math.round(r.avgCompletionHours) : '-'}</td>
                                                    <td>{r.returnedCount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="card-inner">
                                    <div className="alert alert-info">داده‌ای برای بازهٔ انتخابی وجود ندارد.</div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading && !this.state.records.length ? this.renderLoading() : [
            <Header data={this.state.data} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}